var UserEngagement;
(function (UserEngagement) {
    document.addEventListener('ControllerReady', () => {
        const config = retrieveConfig(document);
        const configGet = retrieveConfigGet(document);
        let getServiceEndpoint = `${config.url}` + window.location.pathname + '?jsonFormat&';
        const ServicesEndpointPro = `/api/esb/user/getProfile?_format=form`;
        let sectionUe = document.querySelector('.user-engagement');
        if (getCookie('session_token') != '') {
            getProfile();
        }
        else {
            kettyDo();
        }
        function kettyDo() {
            Fetch(getServiceEndpoint + window.location.search.replace('?', ''), {
                method: 'GET',
                credentials: 'omit'
            }).then(response => {
                if (response.status == 'OK') {
                    loadKettydoSite(response, 'user-engagement-container');
                }
                else {
                    console.log("result: ", response.status);
                    console.log("result message: ", response.message);
                }
                sectionUe.removeAttribute('data-spinner');
            }).catch(err => {
                console.error('Error: ', err);
                sectionUe.removeAttribute('data-spinner');
            });
        }
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function retrieveConfigGet($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config-get');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url-get"]').value;
                    const config = $form.querySelector('[name="config-get"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
        function getProfile() {
            var url = { "token": getCookie('session_token'), "email": getCookie('session_email'), "coopId": getCookie('session_coopId') };
            Fetch(ServicesEndpointPro, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                }
            }).then(response => {
                if (response.header.result == 'OK') {
                    getServiceEndpoint += 'coopId=' + response.payload.profile.coopId + '&pdv=' + response.payload.profile.pdv + '&email=' + response.payload.profile.email + '&userIdCoop' + response.payload.profile.userIdCoop +
                        '&name=' + response.payload.profile.name + '&surname=' + response.payload.profile.surname + '&birthdate=' + response.payload.profile.birthdate + '&token=' + getCookie('session_token') + '&';
                    document.cookie = 'session_info=' + response.payload.profile.coopId + '|' + response.payload.profile.pdv + '|' +
                        response.payload.profile.email + '|' + response.payload.profile.name + '|' + response.payload.profile.surname + '|' +
                        response.payload.profile.birthdate + '; domain = ' + window.location.hostname + '; path = /;secure;';
                }
                kettyDo();
            }).catch(err => {
                console.error('Error: ', err);
                sectionUe.removeAttribute('data-spinner');
            });
        }
    });
})(UserEngagement || (UserEngagement = {}));
